import { Box, chakra } from '@chakra-ui/react';

const vBase = `[role='group']:not(:only-of-type)`;
export const VGroup = chakra(Box, {
  baseStyle: {
    [`${vBase}:not(:first-of-type)`]: {
      marginTop: '-2px',
    },
    [`${vBase}:not(:last-of-type) > input`]: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    [`${vBase}:not(:first-of-type) > input`]: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  },
});

export const Form = chakra('form', {
  baseStyle: {
    "&[aria-invalid='true']": {
      zIndex: 1,
    },
  },
});

const hBase1 = `[role='group']:not(:only-of-type)`;
const hBase2 = `input:not(:only-of-type)`;
export const HGroup = chakra(Box, {
  baseStyle: {
    [`${hBase1}:not(:first-of-type), ${hBase2}:not(:first-of-type)`]: {
      marginLeft: '-2px',
    },
    [`${hBase1}:not(:last-of-type) > input, ${hBase2}:not(:last-of-type)`]: {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
    },
    [`${hBase1}:not(:first-of-type) > input, ${hBase2}:not(:first-of-type)`]: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
});
